import {ReactNode} from 'react'

export const ServiceRequestStep = ({children, className}: { children: ReactNode, className?: string }) => {
    return <div className={`service-request-form-step ${className}`}>{children}</div>
}
